import { render, staticRenderFns } from "./BaseInputDark.vue?vue&type=template&id=07063017&scoped=true"
import script from "./BaseInputDark.vue?vue&type=script&lang=js"
export * from "./BaseInputDark.vue?vue&type=script&lang=js"
import style0 from "./BaseInputDark.vue?vue&type=style&index=0&id=07063017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07063017",
  null
  
)

export default component.exports